import { color, Row, spacer } from 'stylist'
import styled from '@emotion/styled'

const ModalSection = styled.section`
  background-color: ${color('white')};
  border-radius: 3px;
  margin-bottom: auto;
  padding: ${spacer(5)} 0;
`

export default ModalSection



// WEBPACK FOOTER //
// ./src/components/ModalSection.js